import BSInfantCerealProduct from 'models/BSInfantCerealProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSInfantCerealNutrition from './BSInfantCerealNutrition'
import BSInfantCerealPackage from './BSInfantCerealPackage'

const productOptions = {
  nutritionInfo: <BSInfantCerealNutrition />,
  packagingInfo: <BSInfantCerealPackage />,
  productTitle: 'Brand Specific Infant Cereal',
  model: BSInfantCerealProduct,
  validCategories: ['09'],
  validSubCategories: ['001BS'],
  brandSpecific: true,
}

const BSInfantCereal = () => <ProductForm product={productOptions} />

export default BSInfantCereal
